module.exports = __webpack_public_path__ + "static/privacy_policy-fcc95713f0fc00996b455471cf842442.pdf";